export default __webpack_public_path__ + "static/media/gestion_contratos.a0b86ca9.svg";